import * as globals from "../globals";
import ClientConfig = globals.config.ClientConfig;

export const config: ClientConfig = window.clientConfig;